<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <b-card>
      <template slot="header">
        <h3 class="inline">Cadastrar campanha</h3>
        <b-button class="float-right" variant="success" @click="confirmarEnvio"
          >Confirmar Envio</b-button
        >
        <b-button class="float-right m-r-3" variant="danger" @click="goBack"
          >Cancelar Envio</b-button
        >
      </template>
      <b-row>
        <b-col xs="12" lg="12">
          <b-card no-body class="no-margin-bottom">
            <b-tabs
              card
              pills
              vertical
              nav-wrapper-class="w-40"
              v-model="tabIndex[0]"
            >
              <b-tab active title-link-class="tab-link-color">
                <template slot="title">
                  <i class="fa fa-paper-plane tab-icon"></i>
                  {{ tabs[0] }}
                </template>
                <div class="text-center">
                  <b-row>
                    <b-col xl="6" sm="12">
                      <b-input-group prepend="Titulo" class="mb-3">
                        <b-form-input v-model="tituloPush" />
                      </b-input-group>
                    </b-col>
                    <b-col xl="6" sm="12">
                      <b-input-group prepend="Descrição" class="mb-3">
                        <b-form-input v-model="descricaoPush" />
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <h4>Selecione um filtro para realizar o envio dos pushs</h4>
                  <h6>Pushs disponíveis: {{ qtdPush }}</h6>
                  <small
                    >Selecionado:
                    {{
                      pushTabIndex == 0
                        ? "Todos os clientes"
                        : pushTabIndex == 1
                        ? "Por interesse"
                        : "Por seleção"
                    }}</small
                  >
                </div>
                <b-col cols="12">
                  <b-tabs content-class="mt-3" v-model="pushTabIndex">
                    <b-tab title="Todos os clientes" active>
                      <p class="texto-all-clientes">
                        Enviará para todos os clientes cadastrados na plataforma
                        mobile, que totaliza
                        <strong>{{ qtdClientesCadastrados }}</strong>
                        {{
                          qtdClientesCadastrados == 1 ? "cliente" : "clientes"
                        }}.
                      </p>
                    </b-tab>
                    <b-tab title="Por interesse">
                      <p>Enviará de acordo com os interesses selecionados.</p>
                      <b-row>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-form-group>
                            <b-input-group size="sm" prepend="Buscar">
                              <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Digite para pesquisar"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  :disabled="!filter"
                                  @click="filter = ''"
                                  >Limpar</b-button
                                >
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="paginacao"
                            :per-page="perPage"
                            align="fill"
                            size="sm"
                          ></b-pagination>
                        </b-col>
                      </b-row>
                      <b-card header="Interesses">
                        <b-col>
                          <b-table
                            :items="interesses"
                            :fields="interessesFields"
                            striped
                            hover
                            responsive="sm"
                            bordered
                            :filter="filter"
                            :filterIncludedFields="filterOn"
                            @filtered="onFiltered"
                            :current-page="currentPage"
                            :per-page="perPage"
                          >
                            <template #cell(selecionado)="data">
                              <b-button
                                size="md"
                                @click="selecionaInteresse(data.item)"
                                class="mr-2"
                                variant="danger"
                                v-if="verificaInteresseEscolhido(data.item.id)"
                              >
                                -
                              </b-button>
                              <b-button
                                size="md"
                                @click="selecionaInteresse(data.item)"
                                class="mr-2"
                                variant="success"
                                v-else
                              >
                                +
                              </b-button>
                            </template>
                          </b-table>

                          <b-row>
                            <b-col>
                              <b-button
                                class="btn-classic-float-right"
                                variant="success"
                                @click="selecionaTodosInteresses"
                                >Selecionar Todos</b-button
                              >
                              <b-button
                                class="btn-classic-float-right"
                                variant="danger"
                                @click="removerTodosInteresse"
                                >Desmarcar Todos</b-button
                              >
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-card>

                      <b-card header="Interesses selecionados">
                        <b-col>
                          <b-table
                            ref="selectableTable"
                            :items="interessesEscolhidos"
                            :fields="interessesFieldsSelected"
                            striped
                            hovers
                            responsive="sm"
                            bordered
                          >
                            <template #cell(selecionado)="data">
                              <b-button
                                size="md"
                                @click="selecionaInteresse(data.item)"
                                class="mr-2"
                                variant="danger"
                                v-if="verificaInteresseEscolhido(data.item.id)"
                              >
                                -
                              </b-button>
                              <b-button
                                size="md"
                                @click="selecionaInteresse(data.item)"
                                class="mr-2"
                                variant="danger"
                                v-else
                              >
                                -
                              </b-button>
                            </template>
                          </b-table>
                        </b-col>
                      </b-card>
                    </b-tab>
                    <b-tab title="Por seleção">
                      <p>Selecione o(s) clientes(s) para o envio</p>
                      <b-row>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-form-group>
                            <b-input-group size="sm" prepend="Buscar">
                              <b-form-input
                                v-model="filterSelecao"
                                type="search"
                                id="filterInputSelecao"
                                placeholder="Digite para pesquisar"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  :disabled="!filter"
                                  @click="filterSelecao = ''"
                                  >Limpar</b-button
                                >
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col xl="6" lg="6" md="12" sm="12">
                          <b-pagination
                            v-model="currentPageSelecao"
                            :total-rows="paginacaoSelecao"
                            :per-page="perPageSelecao"
                            align="fill"
                            size="sm"
                          ></b-pagination>
                        </b-col>
                      </b-row>
                      <b-card header="Clientes">
                        <b-col>
                          <b-table
                            ref="selectableTable"
                            :items="clientes"
                            :fields="clientesFields"
                            striped
                            hovers
                            responsive="sm"
                            bordered
                            :filter="filterSelecao"
                            :filterIncludedFields="filterOnSelecao"
                            @filtered="onFilteredSelecao"
                            :current-page="currentPageSelecao"
                            :per-page="perPageSelecao"
                          >
                            <template #cell(selecionado)="data">
                              <b-button
                                size="md"
                                @click="selecionaCliente(data.item)"
                                class="mr-2"
                                variant="danger"
                                v-if="verificaClienteEscolhido(data.item.id)"
                              >
                                -
                              </b-button>
                              <b-button
                                size="md"
                                @click="selecionaCliente(data.item)"
                                class="mr-2"
                                variant="success"
                                v-else
                              >
                                +
                              </b-button>
                            </template>
                          </b-table>
                        </b-col>
                      </b-card>
                      <b-card header="Clientes Selecionados">
                        <b-col>
                          <b-table
                            ref="selectableTable"
                            :items="clientesEscolhidos"
                            :fields="clientesFieldsSelected"
                            striped
                            stickycollumn
                            hovers
                            responsive="sm"
                            bordered
                          >
                            <template #cell(selecionado)="data">
                              <b-button
                                size="md"
                                @click="selecionaCliente(data.item)"
                                class="mr-2"
                                variant="danger"
                                v-if="verificaClienteEscolhido(data.item.id)"
                              >
                                -
                              </b-button>
                              <b-button
                                size="md"
                                @click="selecionaCliente(data.item)"
                                class="mr-2"
                                variant="success"
                                v-else
                              >
                                +
                              </b-button>
                            </template>
                          </b-table>
                        </b-col>
                      </b-card>
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Loading from "vue-loading-overlay";

import { Switch as cSwitch } from "@coreui/vue";
import * as config from "@/config.json";
import axios from "axios";

export default {
  name: "configurar-distribuicao",
  components: {
    Loading,
    cSwitch,
  },
  data: function () {
    return {
      isLoading: false,
      id: null,
      titulo: null,
      descricao: null,
      tabIndex: [0],
      tabs: ["Push", "E-mail", "SMS"],
      pushTabIndex: 0,
      qtdClientesCadastrados: 0,
      interesses: [],
      interessesFields: [
        { key: "id", label: "Id" },
        { key: "descricao", label: "Descrição" },
        { key: "quantidade", label: "Clientes atingidos" },
        { key: "selecionado", label: "" },
      ],
      // interessesSelecionados: [],
      interessesEscolhidos: [],
      interessesFieldsSelected: [
        { key: "id", label: "Id" },
        { key: "descricao", label: "Descrição" },
        { key: "selecionado", label: "" },
      ],
      selecionarTodosOsInteresses: false,
      clientes: [],
      clientesFields: [
        "id",
        "nome",
        "sobrenome",
        { key: "email", label: "E-Mail" },
        { key: "numero", label: "Telefone" },
        { key: "selecionado", label: "" },
      ],
      clientesFieldsSelected: [
        "id",
        "nome",
        "sobrenome",
        { key: "email", label: "E-Mail" },
        { key: "numero", label: "Telefone" },
        { key: "selecionado", label: "" },
      ],

      clientesEscolhidos: [],
      selecionarTodosOsClientes: false,
      pushPreparado: null,
      tituloPush: null,
      descricaoPush: null,
      isJornalzinho: null,
      qtdPush: null,
      countEnvio: null,
      tipoid: null,
      redirectid: null,
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 1,
      filterSelecao: null,
      currentPageSelecao: 1,
      perPageSelecao: 5,
      filterOnSelecao: [],
      totalRowsSelecao: 1,
      selected: [],
      chamadaCampanha: "",
    };
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onFilteredSelecao(filteredItems) {
      this.totalRowsSelecao = filteredItems.length;
      this.currentPageSelecao = 1;
    },

    goBack() {
      this.$router.go(-1);
    },

    verificaInteresseEscolhido(id) {
      const filteredInterests = this.interessesEscolhidos.filter(
        (interest) => interest.id == id
      );
      return filteredInterests.length > 0;
    },

    removerInteressePorId(id) {
      const arr = this;
      arr.interessesEscolhidos.forEach(function (el, index) {
        if (el.id === id) {
          arr.interessesEscolhidos.splice(index, 1);
        }
      });
    },

    removerPorId(id) {
      const arr = this;
      arr.clientesEscolhidos.forEach(function (el, index) {
        if (el.id === id) {
          arr.clientesEscolhidos.splice(index, 1);
        }
      });
    },

    selecionaInteresse(record) {
      const interesse = this.interessesEscolhidos.find(
        (interesse) => interesse.id == record.id
      );

      if (!interesse) {
        this.interessesEscolhidos.push({
          id: record.id,
          descricao: record.descricao,
        });
      } else {
        this.removerInteressePorId(record.id);
      }
    },

    async selecionaTodosInteresses() {
      this.removerTodosInteresse();

      await this.interesses.map((interesse) => {
        this.interessesEscolhidos.push({
          id: interesse.id,
          descricao: interesse.descricao,
        });
      });
    },

    removerTodosInteresse() {
      this.interessesEscolhidos.splice(0, this.interessesEscolhidos.length);
    },

    verificaClienteEscolhido(id) {
      const filteredClients = this.clientesEscolhidos.filter(
        (clients) => clients.id == id
      );
      return filteredClients.length > 0;
    },

    selecionaCliente(record) {
      const cliente = this.clientesEscolhidos.find(
        (cliente) => cliente.id == record.id
      );

      if (!cliente) {
        this.clientesEscolhidos.push({
          id: record.id,
          nome: record.nome,
          sobrenome: record.sobrenome,
          email: record.email,
          numero: record.numero,
        });
      } else {
        this.removerPorId(record.id);
      }
    },

    prepararPush() {
      let push = {};
      push.tipo = this.pushTabIndex;
      push.tipoid = this.tipoid;
      push.id_direcionado = this.tipoid == 2 ? this.redirectid : null;
      push.titulo = this.tituloPush;
      push.descricao = this.descricaoPush;
      if (this.pushTabIndex == 1) {
        if (this.interessesEscolhidos.length > 0) {
          push.dados = this.interessesEscolhidos;
        } else {
          return false;
        }
      } else if (this.pushTabIndex == 2) {
        if (this.clientesEscolhidos.length > 0) {
          push.dados = this.clientesEscolhidos;
        } else {
          return false;
        }
      }
      this.pushPreparado = push;
      return true;
    },

    confirmarEnvio() {
      if (this.tituloPush == null) {
        this.$alert(
          "Necessário preencher o título para continuar!",
          "Aviso",
          "warning"
        );
      } else if (this.descricaoPush == null) {
        this.$alert(
          "Necessário preencher a descrição para continuar!",
          "Aviso",
          "warning"
        );
      } else {
        if (!this.prepararPush()) {
          this.$alert(
            "Necessário preencher o filtro para continuar!",
            "Aviso",
            "warning"
          );
        } else {
          this.enviar();
        }
      }
    },
    async enviar() {
      const url = `${config.default.servidor}/gerencial/inserir-envio-push`;

      try {
        this.isLoading = true;
        const response = await axios({
          url,
          method: "put",
          data: {
            cnpj: localStorage.getItem("cnpj"),
            empresaid: localStorage.getItem("enterprise_id").toString(),
            push: this.pushPreparado,
          },
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.isLoading = false;
          await this.$alert("Campanha cadastrada!", "Sucesso", "success");

          if (this.tipoid == 1) this.$router.push({ path: "/jornalzinho" });
          if (this.tipoid == 2) this.$router.push({ path: "/promocoes" });
          if (this.tipoid == 3) this.$router.push({ path: "/sorteios" });
          if (this.tipoid == 4) this.$router.push({ path: "/relatorios" });
          if (this.tipoid == 5) this.$router.push({ path: "/campanhas" });
          if (this.tipoid == 6) this.$router.go(-1);

        }
      } catch (error) {
        this.isLoading = false;
        console.log({ error });
        this.countEnvio = error.response.data.count;
        if (error.response.status == 403) {
          this.$alert(
            `Você não possui saldo de pushs suficiente para completar esta operação.\nSaldo atual: ${this.qtdPush}\nSelecionados para envio: ${this.countEnvio}`,
            "Aviso",
            "warning"
          );
        }
      }
    },

    async getParametros() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-parametros-configurar-distribuicao/${localStorage
        .getItem("enterprise_id")
        .toString()}`;
      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.qtdClientesCadastrados = response.data.todosOsClientes;
          this.interesses = response.data.interesses;
          this.clientes = response.data.clientes;
        }
      } catch (error) {
        await this.$alert(`Erro: ${error}`, "Aviso", "error");
        console.log({ error });
      }
    },

    limpaDadosPush() {
      localStorage.removeItem("tituloSorteio");
      localStorage.removeItem("descricaoSorteio");
      localStorage.removeItem("tituloPromocao");
      localStorage.removeItem("descricaoPromocao");
      localStorage.removeItem("chamadaCampanha");
    },

    async getPushsDisponiveis() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-pushs-disponiveis/${localStorage
        .getItem("enterprise_id")
        .toString()}`;
      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.qtdPush = response.data.pushsDisponiveis;
        }
      } catch (error) {
        await this.$alert(`Erro: ${error}`, "Aviso", "error");
        console.log({ error });
      }
    },

    async verificaTipoCampanha(chamada) {
      this.chamadaCampanha = chamada;

      if (this.chamadaCampanha != "") {
        if (this.chamadaCampanha == "Sorteio") {
          if (localStorage.getItem("tituloSorteio") != "") {
            this.tituloPush = localStorage.getItem("tituloSorteio");
          }

          if (localStorage.getItem("descricaoSorteio") != "") {
            this.descricaoPush = localStorage.getItem("descricaoSorteio");
          }
        } else if (this.chamadaCampanha == "Promocao") {
          if (localStorage.getItem("tituloPromocao") != "") {
            this.tituloPush = localStorage.getItem("tituloPromocao");
          }

          if (localStorage.getItem("descricaoPromocao") != "") {
            this.descricaoPush = localStorage.getItem("descricaoPromocao");
          }
        } else if (this.chamadaCampanha == "Jornalzinho") {
          if (localStorage.getItem("tituloJornalzinho") != "") {
            this.tituloPush = localStorage.getItem("tituloJornalzinho");
          }

          if (localStorage.getItem("descricaoJornalzinho") != "") {
            this.descricaoPush = localStorage.getItem("descricaoJornalzinho");
          }
        }
      }
    },
  },
  async beforeMount() {
    this.tipoid = Number(localStorage.getItem("tipoid"));
    this.redirectid = Number(localStorage.getItem("redirectid"));
    this.id = localStorage.getItem("cod_promocao");

    await this.verificaTipoCampanha(localStorage.getItem("chamadaCampanha"));

    this.limpaDadosPush();

    localStorage.removeItem("cod_promocao");

    this.isLoading = true;
    await this.getParametros();
    await this.getPushsDisponiveis();
    this.isLoading = false;
  },

  computed: {
    paginacao() {
      return this.interesses.length;
    },
    paginacaoSelecao() {
      return this.clientes.length;
    },
  },
};
</script>

